import { decodeRejectReason } from '@/models/Dictionary/RejectReason';
import { ServerApi } from '@/modules/api/server-api';

export const fetchCandidateRejectReasons = (api: ServerApi) => async (resumeId?: string, vacancyId?: number) => {
  const response = await api.get(
    `/v3/dictionary/reject-reasons?type=company&vacancy_id=${vacancyId}&candidate_id=${resumeId}`,
  );
  return response && response.data ? response.data.map(decodeRejectReason) : [];
};
